var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiGenerativeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m49.7 43.72-12 37.44A1.39 1.39 0 0 0 39 83h3.36a1.39 1.39 0 0 0 1.33-1l1.88-6H62l-.23-.37L63.83 82a1.39 1.39 0 0 0 1.33 1h3.36a1.39 1.39 0 0 0 1.33-1.82l-12-37.44a1.4 1.4 0 0 0-1.33-1H51a1.39 1.39 0 0 0-1.3.98ZM47.57 70l6.19-19.27L60 70Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 40.24,
    x: 79,
    y: 42.75,
    rx: 1.4,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.26 98h-29.1A8.16 8.16 0 0 1 30 89.84V38.16A8.16 8.16 0 0 1 38.16 30h51.68A8.16 8.16 0 0 1 98 38.16V64a2.07 2.07 0 0 0 2.12 2 11 11 0 0 1 4.91 1.14 2.06 2.06 0 0 0 3-1.87V38.16A18.16 18.16 0 0 0 89.84 20H38.16A18.16 18.16 0 0 0 20 38.16v51.68A18.16 18.16 0 0 0 38.16 108h33.3a2.07 2.07 0 0 0 1.47-3.53 16.13 16.13 0 0 1-3.71-5.06A2.11 2.11 0 0 0 67.26 98Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.73 101.8 9.06-3.57a1 1 0 0 0 0-1.86l-9.06-3.57a12.61 12.61 0 0 1-7.09-7.09l-3.57-9a1 1 0 0 0-.93-.63 1 1 0 0 0-.93.63l-3.57 9a12.58 12.58 0 0 1-7.09 7.09l-9 3.57a1 1 0 0 0 0 1.86l9 3.57a12.58 12.58 0 0 1 7.09 7.09l3.57 9a1 1 0 0 0 .93.64 1 1 0 0 0 .93-.64l3.57-9a12.61 12.61 0 0 1 7.09-7.09Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiGenerativeWhite);
export default __webpack_public_path__ + "static/media/ai-generative-white.d6f7ce693868b450f05afef7a764f295.svg";
export { ForwardRef as ReactComponent };